import { useSelector } from "react-redux";
import { userPreferencesDefaults } from "common/user-preferences-defaults";
import { useGetUserPreferences } from "hooks/use-get-user-preferences";
import { useGetAllocationKey, useGetCommitmentCalculation } from "hooks/use-tenant-settings";
import { allocationKeyEnumValues } from "hooks/widget-data/use-datapoints";
export const useGetUserAllocationKey = () => {
    const [userPreferences] = useGetUserPreferences();
    const tenantAllocationKey = useGetAllocationKey();
    return userPreferences?.allocationKey ? allocationKeyEnumValues(userPreferences?.allocationKey) : tenantAllocationKey;
};
export const useGetUnitOfAreaKey = () => {
    const [userPreferences] = useGetUserPreferences();
    return userPreferences?.unitOfArea ?? userPreferencesDefaults.unitOfArea;
};
export const useGetUserCommitmentCalculation = () => {
    const [userPreferences] = useGetUserPreferences();
    const tenantCommitmentCalculation = useGetCommitmentCalculation();
    return userPreferences?.commitmentCalculation ?? tenantCommitmentCalculation;
};
export const useGetUsername = () => useSelector((state) => state.auth.oidc?.user?.profile?.sub);
